module.exports = __webpack_public_path__ + "static/media/Land Rover.bde9c20b.jpeg";